module.exports = __webpack_public_path__ + "assets/img/22.603387e4.png";